import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { subscriptionApi, type CreateSubscriptionInput } from '../services/subscriptionApi';

export function useCreateSubscription() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (input: CreateSubscriptionInput) => subscriptionApi.create(input),
    onSuccess: () => {
      if (user?.id) {
        queryClient.invalidateQueries({ queryKey: ['subscription', user.id] });
      }
      queryClient.invalidateQueries({ queryKey: ['premium-price'] });
      queryClient.invalidateQueries({ queryKey: ['saved-payment-methods'] });
    },
  });
}
